import { render, staticRenderFns } from "./OrdersContainerView.vue?vue&type=template&id=3005fd26&"
import script from "./OrdersContainerView.vue?vue&type=script&lang=js&"
export * from "./OrdersContainerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports